import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { Match } from '../../_shared/models/match.model';
import { StatsFilter } from '../../_shared/models/statsFilters.model';
import { StatsFilterUpdaterComponent } from './stats-filter-updater/stats-filter-updater.component';

@Component({
  standalone: false,
    selector: 'app-stats-filters',
    templateUrl: './stats-filters.component.html',
    styleUrls: ['./stats-filters.component.scss'],
})
export class StatsFiltersComponent {
    @Output() updateFilters = new EventEmitter<any>();
    @Input() match: Match;
    filters = new StatsFilter();

    filterCount = 0;
    constructor(
        private modalController: ModalController,
        private routerOutlet: IonRouterOutlet
    ) { }

    async filtersModal() {
        const modal = await this.modalController.create({
            component: StatsFilterUpdaterComponent,
            componentProps: {
                filters: this.filters,
                match: this.match
            },
            presentingElement: this.routerOutlet.nativeEl
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();
        this.filters = data;
        this.filterCount = 0;
        Object.keys(this.filters).forEach(
            key => {
                if (this.filters[key]) {
                    this.filterCount++;
                }
            }
        );
        this.updateFilters.emit(this.filters);
    }

}
